module.exports = __webpack_public_path__ + "img/nucleus_blue.6d998bfd.svg";